import {
  CUSTOMER_TYPE_CSP,
  DEFAULT_CART_SETTINGS_COMPACT,
  DEFAULT_CART_SETTINGS_STANDARD,
  FULFILLMENT_TYPE_PICKUP
} from '@app/components/pages/account/shopping-preferences/constants';
import { isEmpty } from '@app/utils';

export const getLanguageDetails = (languages = {}) =>
  Object.values(languages).map(
    ({ nativeDescriptionString: displayName, languageId: value }) => ({
      displayName,
      value
    })
  );

export const getFulfillmentGridProps = (isMD, isBlg, noOptions) => {
  if (!isBlg) {
    return {
      variant: isMD && noOptions ? '3up' : '',
      gap: 'xs'
    };
  }

  return {
    variant: noOptions ? '1-4up' : 'side-by-side'
  };
};

export const getVariantTitle = (isMD, isBlg) => {
  if (isBlg) {
    return 'title';
  } else if (isMD) {
    return 'title-sm';
  }
  return 'display-sm';
};

export const setDefaultValues = (
  initialFormValues,
  shoppingPreferencesData,
  languageOptions
) => {
  const { customerType } = shoppingPreferencesData;
  const isCsp = customerType === CUSTOMER_TYPE_CSP;
  const startPageDefault = shoppingPreferencesData?.startPage?.filter(
    page => page.default
  )[0];
  const langDefault =
    initialFormValues?.loginDefaultLangSettings &&
    languageOptions?.filter(
      item => initialFormValues.loginDefaultLangSettings === item.displayName
    )[0];
  const paymentMethodDefault = shoppingPreferencesData?.paymentMethods?.filter(
    method => method.default
  )[0];

  return {
    ...initialFormValues,
    loginStartPageSettings: startPageDefault,
    loginDefaultLangSettings: langDefault,
    paymentMethod: paymentMethodDefault,
    ...(isCsp &&
      isEmpty(initialFormValues?.editOrderByInformation) && {
        editOrderByInformation: true
      }),
    ...(isEmpty(initialFormValues?.orderDetailsAttachQuote) && {
      orderDetailsAttachQuote: true
    }),
    ...(isCsp &&
      isEmpty(initialFormValues?.shoppingCartDisplayOrderInfo) && {
        shoppingCartDisplayOrderInfo: true
      }),
    ...(isCsp &&
      isEmpty(initialFormValues?.shoppingCartAddNotes) && {
        shoppingCartAddNotes: true
      }),
    ...(isEmpty(initialFormValues?.paymentPoNumberToggle) && {
      paymentPoNumberToggle: true
    }),
    ...(isEmpty(initialFormValues?.fulfillment) && {
      fulfillment: FULFILLMENT_TYPE_PICKUP
    }),
    shoppingCartPrefs: {
      ...initialFormValues?.shoppingCartPrefs,
      ...(isEmpty(initialFormValues?.shoppingCartPrefs?.pageView) && {
        ...(!isCsp
          ? DEFAULT_CART_SETTINGS_STANDARD
          : DEFAULT_CART_SETTINGS_COMPACT)
      })
    }
  };
};

export const getFormValues = (formValues, headlessShoppingCartFlag) => {
  return {
    ...formValues,
    ...(!isEmpty(formValues?.loginDefaultLangSettings) && {
      loginDefaultLangSettings: formValues?.loginDefaultLangSettings.displayName
    }),
    ...(!isEmpty(formValues?.loginStartPageSettings) && {
      loginStartPageSettings: formValues?.loginStartPageSettings.displayName
    }),
    ...(!isEmpty(formValues?.paymentMethod) && {
      paymentMethod: formValues?.paymentMethod.displayName
    }),
    ...(headlessShoppingCartFlag &&
      !isEmpty(formValues?.shoppingCartPrefs?.partOrItem?.displayImages) && {
        imageSettings: formValues?.imageSettings.map(img => ({
          ...img,
          default: formValues?.shoppingCartPrefs.partOrItem.displayImages
        }))
      })
  };
};

export const getLabelStyle = isMD => {
  return isMD
    ? 'cat-u-theme-typography-label'
    : 'cat-u-theme-typography-label-sm';
};

export const getReadOnlyTextStyle = isMD => {
  return isMD
    ? 'cat-u-theme-typography-body'
    : 'cat-u-theme-typography-body-sm';
};
